import { _, React, Component, Container } from 'utils';
import { ActiveStore, Creators } from 'model'
import Position from './Position';
import AreaFilters from './Area';

class Filters extends Component {

	static getStores() {
		return [ActiveStore];
	}

	static calculateState(state) {
		var state = ActiveStore.getState();

		return {
			filters: state.filters
		}
	}

	render() {
		var { filters } = this.state;

		return <div className="panel panel-default">
			<div className="panel-heading"><h3 className="panel-title">{ _("Filteri") }</h3></div>
			<div className="panel-body">
				<AreaFilters type="area" filters={ filters } />
			</div>
		</div>
	}

}

export default Container.create(Filters);




// WEBPACK FOOTER //
// ./src/modules/app/filters/Filters.js